import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { teamsStoreKey } from './teams.const';
import { ITeamsSliceState } from './teams.types';
import { fetchTeams, loadMemberDetails } from './teams.thunk';
import { ApiStatus } from '@constants';
import { setImpersonation } from '@redux/accounts';

const initialState: ITeamsSliceState = {
  apiStatus: ApiStatus.IDLE,
  data: null,
  memberDetails: {
    data: null,
    apiStatus: ApiStatus.IDLE,
  },
};

const teamsSlice = createSlice({
  name: teamsStoreKey,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTeams.pending, (state) => {
        state.apiStatus = ApiStatus.LOADING;
      })
      .addCase(
        fetchTeams.fulfilled,
        (state, action: PayloadAction<ITeamsSliceState['data']>) => {
          state.apiStatus = ApiStatus.COMPLETE;
          state.data = action.payload;
        },
      )
      .addCase(fetchTeams.rejected, (state) => {
        state.apiStatus = ApiStatus.FAILED;
      })
      .addCase(setImpersonation.pending, () => ({
        ...initialState,
        apiStatus: ApiStatus.LOADING,
        memberDetails: {
          data: null,
          apiStatus: ApiStatus.LOADING,
        },
      }))
      .addCase(loadMemberDetails.pending, (state) => {
        state.memberDetails.apiStatus = ApiStatus.LOADING;
      })
      .addCase(loadMemberDetails.fulfilled, (state, action) => {
        state.memberDetails.data = action.payload;
        state.memberDetails.apiStatus = ApiStatus.COMPLETE;
      })
      .addCase(loadMemberDetails.rejected, (state, action) => {
        if (action.error.message?.includes('403')) {
          state.memberDetails.apiStatus = ApiStatus.FORBIDDEN;
        } else {
          state.memberDetails.apiStatus = ApiStatus.FAILED;
        }
      });
  },
});

export const teamsReducer = teamsSlice.reducer;
